<sh-form-group [label]="label" [id]="id" (shClickOutside)="setDropdownClosed()" [formGroupStyling]="formGroupStyling">
    <sh-droppanel
        [inOverflownContainer]="inOverflownContainer"
        [height]="height"
        [openDirection]="openDirection"
        [droppanelStyle]="droppanelStyle"
        [isOpen$]="isOpen$"
        [hasOptions$]="hasOptions$"
        [limitHeightToViewport$]="limitHeightToViewport$"
        [loading$]="loading$"
        [focusMode]="focusIndex >= 0"
    >
        <div droppanelToggle #toggleContainer (keyup)="handleDeletePress($event)">
            <button [id]="id" type="button" class="sh-icon-button sh-form-group__input sh-form-multiselect__select" (click)="toggleDropdown()" [title]="label">
                <span class="sh-form-multiselect__select__label">{{ selectLabel$ | async }}</span>
                <svg sh-icon class="sh-icon-button__icon--end push-right" [name]="'angle-down'" [size]="'small'" aria-hidden="true"></svg>
            </button>
        </div>

        @if (search) {
            <div class="sh-droppanel__search" header>
                <div class="sh-input-field-with-icon">
                    <input
                        #searchInput
                        type="search"
                        autocomplete="off"
                        [id]="id + '-search-input'"
                        [formControl]="searchControl"
                        [placeholder]="searchPlaceholderMsg"
                        class="sh-input-field sh-input-field-with-icon__input sh-droppanel__search__input"
                        (mouseenter)="onSearchFocus()"
                        (focus)="onSearchFocus()"
                    />
                    <svg sh-icon class="sh-input-field-with-icon__icon" [name]="'search'" [size]="sizes.SMALL" aria-hidden="true"></svg>
                </div>
            </div>
        }

        @if ((loading$ | async) === true) {
            <ul class="sh-droppanel__list" [id]="id + '-list'">
                <li class="sh-droppanel__list__item sh-droppanel__list-action sh-no-pointer-events">
                    <i>{{ loadingMsg }}</i>
                </li>
            </ul>
        } @else {
            @if (options$ | async; as options) {
                <ul #optionContainer shChildIndex class="sh-droppanel__list" [id]="id + '-list'">
                    <ng-container
                        *ngFor="let option of options; let index = index; trackBy: trackByFn"
                        [ngTemplateOutlet]="multiple ? checkbox : noCheckbox"
                        [ngTemplateOutletContext]="{ option: option, index: index }"
                    ></ng-container>
                    @if (showNoResultsAction$ | async) {
                        <sh-action-item
                            class="sh-droppanel__list__item sh-droppanel__list-action sh-no-results-action"
                            [item]="$noResultsAction()"
                            (keyup.enter)="setDropdownClosed()"
                            (click)="setDropdownClosed()"
                            [disableArrowNavigation]="true"
                            (mouseenter)="onHover($event)"
                        ></sh-action-item>
                    }
                    @if (!(showNoResultsAction$ | async)) {
                        @if (options.length === 0) {
                            <li class="sh-droppanel__list__item sh-droppanel__list-action sh-no-pointer-events">
                                <i>{{ noResultsFoundMsg }}</i>
                            </li>
                        }
                    }
                    <sh-action-item
                        [ngStyle]="{ display: showMoreMsg && (showExtraItemsLabelIndicator$ | async) ? 'block' : 'none' }"
                        class="sh-droppanel__list__item sh-droppanel__list-action"
                        [bubbleEvent]="false"
                        [item]="loadMoreActionItem"
                        [disableArrowNavigation]="true"
                        (mouseenter)="onHover($event)"
                    ></sh-action-item>
                </ul>
            }
        }
    </sh-droppanel>
</sh-form-group>

<ng-template #checkbox let-option="option" let-index="index">
    <li
        class="sh-droppanel__list__item"
        [class.sh-visually-hidden]="loading$ | async"
        [title]="option.disabled && option.disabledInfoMsg ? option.disabledInfoMsg : ''"
        (mouseenter)="onHover($event)"
    >
        @if ({ state: getState(option) }; as el) {
            <label
                tabindex="-1"
                class="sh-droppanel__list-action"
                [for]="id + '-option-' + index"
                [class.-sh-disabled]="isDisabled(option, el.state)"
                (keydown.enter)="toggleCheckbox($event, option)"
                (keyup.space)="toggleCheckbox($event, option)"
            >
                <input
                    type="checkbox"
                    tabindex="-1"
                    [id]="id + '-option-' + index"
                    class="sh-checkbox sh-droppanel__list-action__checkbox"
                    [checked]="el.state === states.SET"
                    [shIndeterminate]="el.state === states.INDETERMINATE"
                    [class.-sh-disabled]="isDisabled(option, el.state)"
                    [disabled]="isDisabled(option, el.state)"
                    (change)="toggleCheckbox($event, option)"
                />
                <span class="sh-droppanel__list-action__label">
                    <ng-container [ngSwitch]="el.state">
                        <ng-container *ngSwitchCase="states.INDETERMINATE">
                            <i style="padding-right: 0.5rem">{{ option.label }}</i>
                        </ng-container>
                        <ng-container *ngSwitchCase="states.SET">
                            <b>{{ option.label }}</b>
                        </ng-container>
                        <ng-container *ngSwitchDefault>{{ option.label }}</ng-container>
                    </ng-container>
                </span>
            </label>
        }
    </li>
</ng-template>

<ng-template #noCheckbox let-option="option">
    @if ({ state: getState(option) }; as el) {
        <li
            tabindex="-1"
            class="sh-droppanel__list__item sh-droppanel__list-action"
            [class.sh-visually-hidden]="loading$ | async"
            [class.-sh-disabled]="option.disabled"
            [title]="option.disabled && option.disabledInfoMsg ? option.disabledInfoMsg : option.label"
            (click)="selectSingleValue(option)"
            (keydown.enter)="selectSingleValue(option)"
            (mouseenter)="onHover($event)"
        >
            <span class="sh-droppanel__list-action__label">
                <ng-container *ngIf="el.state === states.SET">
                    <b>{{ option.label }}</b>
                </ng-container>
                <ng-container *ngIf="el.state === states.INDETERMINATE">
                    <i style="padding-right: 0.5rem">{{ option.label }}</i>
                </ng-container>
                <ng-container *ngIf="el.state === states.UNSET">{{ option.label }}</ng-container>
            </span>
        </li>
    }
</ng-template>
